import { Auth } from '@/lib/mobx/auth.mobx';
import { BetBuilder } from '@/lib/mobx/models/BetBuilder.mobx';
import { BetslipBonus } from '@/lib/mobx/models/BetslipBonus.mobx';
import { BetslipErrors } from '@/lib/mobx/models/BetslipErrors.mobx';
import { Betslip } from '@/lib/mobx/models/betslip.mobx';
import { Categorizer } from '@/lib/mobx/models/Categorizer.mobx';
import { ExpressPresets } from '@/lib/mobx/models/ExpressPresets.mobx';
import { StoreMobxMain } from '@/lib/mobx/models/index.mobx';
import { Leaderboards } from '@/lib/mobx/models/Leaderboards.mobx';
import { Search } from '@/lib/mobx/models/Search.mobx';
import { ShareBet } from '@/lib/mobx/models/ShareBet.mobx';
import { SwipeBets } from '@/lib/mobx/models/SwipeBets.mobx';
import { TopEventsSlider } from '@/lib/mobx/models/TopEventsSlider.mobx';
import { UI } from '@/lib/mobx/models/UI.mobx';
import { Profile } from '@/lib/mobx/Profile';
import { ProfileMyBets } from '@/lib/mobx/profileMyBets';

import { initialStore } from './initialStateMobx';

export class RootStoreMobx {
  store: StoreMobxMain;
  ui: UI;
  betslip: Betslip;
  profile: Profile;
  auth: Auth;
  mybets: ProfileMyBets;
  leaderboards: Leaderboards;
  betslipBonus: BetslipBonus;
  expressPresets: ExpressPresets;
  betslipErrors: BetslipErrors;
  betBuilder: BetBuilder;
  categorizer: Categorizer;
  search: Search;
  shareBet: ShareBet;
  swipeBets: SwipeBets;
  topEventsSlider: TopEventsSlider;

  constructor() {
    const { ui, store, betslip, auth } = initialStore;

    this.store = new StoreMobxMain(this, store);
    this.ui = new UI(this, ui);
    this.betslip = new Betslip(this, betslip);
    this.profile = new Profile(this);
    this.auth = new Auth(this, auth);
    this.mybets = new ProfileMyBets(this);
    this.leaderboards = new Leaderboards(this);
    this.betslipBonus = new BetslipBonus(this);
    this.expressPresets = new ExpressPresets(this);
    this.betslipErrors = new BetslipErrors(this);
    this.betBuilder = new BetBuilder(this);
    this.categorizer = new Categorizer(this);
    this.search = new Search(this);
    this.shareBet = new ShareBet();
    this.topEventsSlider = new TopEventsSlider(this);
    this.swipeBets = new SwipeBets(this);
  }
}

/* Types */
export type TRootStore = RootStoreMobx;
